import { render, staticRenderFns } from "./TableDocuments.vue?vue&type=template&id=a1006574&scoped=true&"
import script from "./TableDocuments.ts?vue&type=script&lang=ts&"
export * from "./TableDocuments.ts?vue&type=script&lang=ts&"
import style0 from "./TableDocuments.vue?vue&type=style&index=0&id=a1006574&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1006574",
  null
  
)

export default component.exports
import {QTable,QSpace,QInput,QIcon,QCard,QCardSection,QSeparator,QBtn,QMenu,QTr,QTd,QPagination} from 'quasar'
component.options.components = Object.assign({QTable,QSpace,QInput,QIcon,QCard,QCardSection,QSeparator,QBtn,QMenu,QTr,QTd,QPagination}, component.options.components || {})
